import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '@app/constants/constants';
import { MethodsHelper } from '@app/helpers/methods.helper';

@Component({
    selector: 'app-off-balance-account-statement-popup',
    templateUrl: './off-balance-account-statement-popup.component.html',
    styleUrls: ['./off-balance-account-statement-popup.component.css'],
    standalone: false
})

export class OffBalanceAccountStatementPopupComponent implements OnInit {

  @Input() accountNumber: string;
  @Input() displayDialog: boolean;
  @Output() onSubmit = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  startDate: Date;
  endDate: Date;
  period: string;
  showDailyTurnOvers: boolean = false;
  yearRange = MethodsHelper.getYearRange(-1);
  readonly periods = Constants.TurnoverPeriods;

  submittedForm: boolean = false;
  @ViewChild('form') form: any;


  constructor(
    private router: Router,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.endDate = localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date();
    this.startDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), 1);
    this.period = 'CURRENT_MONTH';
  }

  cancel() {
    this.onCancel.emit();
  }

  save() {
    this.saveData();
  }

  calculatePeriod() {
    const result: [Date, Date] | void = MethodsHelper.calculatePeriod(this.period, new Date());

    if (result) {
      this.startDate = result[0];
      this.endDate = result[1];
    }
  }

  generateAccountStatement(id: string, startDate, endDate) {
    const queryParams = this.period ? { queryParams: { period: this.period } } : undefined;

    this.onSubmit.emit();
    let routeDates = '';
    if (startDate && endDate) {
      routeDates = '/' + this.datePipe.transform(startDate, "dd-MM-yyyy") + '/' +
        this.datePipe.transform(endDate, "dd-MM-yyyy") + '/' +
        this.showDailyTurnOvers;
    }
    this.router.navigate(['user/off-balance-account-statement/' + id + routeDates], queryParams);
  }

  validateForm() {
    if (this.form.form) {
      return this.form.form.valid;
    }
    return false;
  }

  saveData() {
    this.submittedForm = true;
    if (this.validateForm()) {
      this.generateAccountStatement(this.accountNumber, this.startDate, this.endDate);
    }
  }

  changePeriodDate(changeFrom) {
    if (MethodsHelper.compareDates(this.datePipe.transform(this.endDate, "dd-MM-yyyy"),this.datePipe.transform(this.startDate, "dd-MM-yyyy")) === -1) {
      if (changeFrom) {
        this.endDate = this.startDate;
      } else {
        this.startDate = this.endDate;
      }
    }
    this.period = undefined;
  }

}
